<template>
  <BasePaymentForm
    :showSecured="true"
  >
    <template #body>
      <div class="form-group mb-1">
        <label>
          <strong>
            {{ $t('apps.payment.message.item') }}
          </strong>
        </label>
      </div>
      <div class="form-group mb-1">
        <Table :invoice="invoice"/>
      </div>
    </template>
    <template #footer-text>
      {{ $t('apps.payment.message.amounttotal') }}:
      {{ getCurrencyWithNumber(numberel(invoice.total, '0,0.00')) }}
    </template>
    <template #footer-actions>
      <BaseButton
        :text="$t('button.next')"
        :className="`btn-web`"
        @click="onClickNext"
      />
    </template>
  </BasePaymentForm>
</template>

<script>
import Table from '@/components/payment/InvoiceListTable.vue'

export default {
  components: {
    Table,
  },

  props: {
    invoice: {
      type: Object,
      default: () => ({}),
    },
  },

  methods: {
    onClickNext () {
      this.$emit('next')
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/payment/InvoiceList.vue